import '../css/app.scss';
import { stickyHeader } from './modules/globalHeader';
import { drawer } from './modules/drawer';
import { scrollToTopLink } from './modules/scrollToTopLink';
import { studentWorksGallery } from './modules/studentWorksGallery';
import { singleStudent } from './modules/singleStudent';

'use strict';
(function(window, document, $) {
  $(function() {
    drawer();
    stickyHeader();

    scrollToTopLink();

    const bodyClassList = document.body.classList;
    if (bodyClassList.contains('p-single-student')) {
      studentWorksGallery();
      singleStudent();
    }
  });
})(window, document, jQuery);